export default {
      id: "archive-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#archive-usage",
      toString: function () {
        return this.url;
      }
    }